import CardFile from "./CardFile";
import './default.css';


declare global {
    interface Window {
        CardFile: typeof CardFile;
    }
}

window.CardFile = CardFile;